import React from 'react';
import '../styles/Features.css';

const Features = () => {
  return (
    <section className="features">
      <div className="container">
        <h2 className="features-heading">Click. Download. Protected.</h2>
        
        <div className="features-workflow">
          <div className="feature-card">
            <div className="feature-number">1</div>
            <div className="feature-icon">
              <img src="/images/img1.png" alt="Instant Download" className="feature-image" />
            </div>
            <h3 className="feature-title">INSTANT DOWNLOAD</h3>
            <p className="feature-description">Get lawyer-grade templates with one click.</p>
          </div>

          <div className="workflow-connector">
            <div className="connector-line"></div>
            <div className="connector-arrow"></div>
          </div>
          
          <div className="feature-card">
            <div className="feature-number">2</div>
            <div className="feature-icon">
              <img src="/images/img2.png" alt="Review and Edit" className="feature-image" />
            </div>
            <h3 className="feature-title">REVIEW & EDIT</h3>
            <p className="feature-description">Use our plain-language cheat sheet to customize.</p>
          </div>

          <div className="workflow-connector">
            <div className="connector-line"></div>
            <div className="connector-arrow"></div>
          </div>
          
          <div className="feature-card">
            <div className="feature-number">3</div>
            <div className="feature-icon">
              <img src="/images/img3.png" alt="Implement" className="feature-image" />
            </div>
            <h3 className="feature-title">PUT IT TO WORK</h3>
            <p className="feature-description">Start using your contract immediately with confidence.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
